/**
 * Whether this runtime's ICU can format in `zone` (an IANA name). A zone the
 * server knows but the browser's tz data does not (a renamed or brand-new
 * zone) makes `Intl.DateTimeFormat` throw a `RangeError` — checking first lets
 * a caller fall back to its own zone instead of taking the whole view down.
 */
export function isSupportedTimeZone(zone: string): boolean {
  if (zone === '') return false;
  try {
    new Intl.DateTimeFormat(undefined, { timeZone: zone }).format(0);
    return true;
  } catch {
    return false;
  }
}
